import React, { useEffect, useState, Fragment } from "react";
import { Row, Col, Card, Button, Modal, Form, Badge, Spinner } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import api from "../../../api";
import swal from "sweetalert";

const STATE_LIST = [
 { name: "Jammu & Kashmir", code: "01" },
 { name: "Himachal Pradesh", code: "02" },
 { name: "Punjab", code: "03" },
 { name: "Chandigarh", code: "04" },
 { name: "Uttarakhand", code: "05" },
 { name: "Haryana", code: "06" },
 { name: "Delhi", code: "07" },
 { name: "Rajasthan", code: "08" },
 { name: "Uttar Pradesh", code: "09" },
 { name: "Bihar", code: "10" },
 { name: "Sikkim", code: "11" },
 { name: "Arunachal Pradesh", code: "12" },
 { name: "Nagaland", code: "13" },
 { name: "Manipur", code: "14" },
 { name: "Mizoram", code: "15" },
 { name: "Tripura", code: "16" },
 { name: "Meghalaya", code: "17" },
 { name: "Assam", code: "18" },
 { name: "West Bengal", code: "19" },
 { name: "Jharkhand", code: "20" },
 { name: "Odisha", code: "21" },
 { name: "Chhattisgarh", code: "22" },
 { name: "Madhya Pradesh", code: "23" },
 { name: "Gujarat", code: "24" },
 { name: "Daman & Diu", code: "25" },
 { name: "Dadra & Nagar Haveli", code: "26" },
 { name: "Maharashtra", code: "27" },
 { name: "Andhra Pradesh (Old)", code: "28" },
 { name: "Karnataka", code: "29" },
 { name: "Goa", code: "30" },
 { name: "Lakshadweep", code: "31" },
 { name: "Kerala", code: "32" },
 { name: "Tamil Nadu", code: "33" },
 { name: "Puducherry", code: "34" },
 { name: "Andaman & Nicobar Islands", code: "35" },
 { name: "Telangana", code: "36" },
 { name: "Andhra Pradesh (New)", code: "37" },
 { name: "Ladakh", code: "38" },
];

const OfficeMaster = () => {
 const [list, setList] = useState([]);
 const [filtered, setFiltered] = useState([]);
 const [loading, setLoading] = useState(false);
 const [saving, setSaving] = useState(false);

 const [showModal, setShowModal] = useState(false);
 const [editId, setEditId] = useState(null);
 const [search, setSearch] = useState("");
 const [logoFile, setLogoFile] = useState(null);

 const [form, setForm] = useState({
 officeName: "",
 companyName: "",
 address: "",
 emailId: "",
 gstin: "",
 phone: "",
 website: "",
 isActive: true,
 slogan: "",
 state: "",
 stateCode: "",
 });

 const fetchOffices = async () => {
 setLoading(true);
 try {
 const res = await api.get("/offices");
 if (res.data.success) {
 setList(res.data.data);
 setFiltered(res.data.data);
 }
 } finally {
 setLoading(false);
 }
 };

 useEffect(() => {
 fetchOffices();
 }, []);

 useEffect(() => {
 if (!search.trim()) setFiltered(list);
 else {
 const s = search.toLowerCase();
 setFiltered(list.filter((i) => 
 i.officeName.toLowerCase().includes(s) || 
 i.companyName.toLowerCase().includes(s) ||
 i.address.toLowerCase().includes(s)
 ));
 }
 }, [search, list]);

 const openAdd = () => {
 setEditId(null);
 setForm({
 officeName: "",
 companyName: "",
 address: "",
 emailId: "",
 gstin: "",
 phone: "",
 website: "",
 isActive: true,
 slogan: "",
 state: "",
 stateCode: "",
 });
 setLogoFile(null);
 setShowModal(true);
 };

 const openEdit = (item) => {
 setEditId(item._id);
 setForm({
 officeName: item.officeName,
 companyName: item.companyName,
 address: item.address,
 emailId: item.emailId || "",
 gstin: item.gstin || "",
 phone: item.phone || "",
 website: item.website || "",
 isActive: item.isActive,
 slogan: item.slogan || "",
 state: item.state || "",
 stateCode: item.stateCode || "",
 });
 setLogoFile(null);
 setShowModal(true);
 };

 const closeModal = () => {
 if (!saving) setShowModal(false);
 };

 const handleChange = (e) => {
 const { name, value, type, checked, files } = e.target;
 
 if (type === 'file') {
 setLogoFile(files[0]);
 } else if (name === 'state') {
 const selectedState = STATE_LIST.find(s => s.name === value);
 setForm({ 
 ...form, 
 state: value, 
 stateCode: selectedState ? selectedState.code : "" 
 });
 } else {
 setForm({ 
 ...form, 
 [name]: type === 'checkbox' ? checked : value 
 });
 }
 };

 const handleSave = async () => {
 if (!form.officeName.trim() || !form.companyName.trim() || !form.address.trim()) {
 return swal("Validation", "Office name, company name, and address are required", "warning");
 }

 try {
 setSaving(true);
 const formData = new FormData();
 Object.keys(form).forEach(key => {
 formData.append(key, form[key]);
 });
 if (logoFile) {
 formData.append("logo", logoFile);
 }

 if (editId) {
 await api.put(`/offices/${editId}`, formData, {
 headers: { "Content-Type": "multipart/form-data" }
 });
 } else {
 await api.post("/offices", formData, {
 headers: { "Content-Type": "multipart/form-data" }
 });
 }

 swal("Success", "Office saved successfully", "success");
 closeModal();
 fetchOffices();
 } catch (err) {
 swal(
 "Error",
 err.response?.data?.message || "Operation failed",
 "error"
 );
 } finally {
 setSaving(false);
 }
 };

 const handleDelete = (item) => {
 swal({
 title: `Delete "${item.officeName}"?`,
 text: "This action cannot be undone.",
 icon: "warning",
 buttons: true,
 dangerMode: true,
 }).then(async (ok) => {
 if (!ok) return;
 try {
 await api.delete(`/offices/${item._id}`);
 fetchOffices();
 } catch (err) {
 swal(
 "Error",
 err.response?.data?.message || "Cannot delete",
 "error"
 );
 }
 });
 };

 return (
 <Fragment>
 <PageTitle activeMenu="Office Master" motherMenu="Masters" />

 <Row>
 <Col lg={12}>
 <Card>
 <Card.Header className="d-flex justify-content-between">
 <Card.Title>Offices / Branches</Card.Title>
 <Button onClick={openAdd}>+ Add Office</Button>
 </Card.Header>

 <Card.Body>
 <Form.Control
 className="mb-3"
 placeholder="Search office..."
 value={search}
 onChange={(e) => setSearch(e.target.value)}
 />

 {loading ? (
 <div className="text-center py-5">
 <Spinner animation="border" />
 </div>
 ) : (
 <div className="table-responsive">
 <table className="table table-bordered table-hover">
 <thead className="table-light">
 <tr>
 <th>Logo</th>
 <th>Office Name</th>
 <th>Company Name</th>
 <th>Address</th>
 <th>GSTIN</th>
 <th>Status</th>
 <th width="170">Actions</th>
 </tr>
 </thead>
 <tbody>
 {filtered.map((item) => (
 <tr key={item._id}>
 <td className="text-center">
 {item.logo ? (
 <img 
 src={`${process.env.REACT_APP_API_URL}/${item.logo}`} 
 alt="Logo" 
 style={{ height: "40px", width: "40px", objectFit: "contain" }}
 />
 ) : (
 <Badge bg="primary" className="rounded-pill">No Logo</Badge>
 )}
 </td>
 <td>{item.officeName}</td>
 <td>{item.companyName}</td>
 <td>{item.address}</td>
 <td>{item.gstin || "-"}</td>
 <td>
 <Badge bg={item.isActive ? "success" : "secondary"} className="rounded-pill">
 {item.isActive ? "Active" : "Inactive"}
 </Badge>
 </td>
 <td>
 <Button
 size="sm"
 variant="warning"
 className="me-2"
 onClick={() => openEdit(item)}
 >
 Edit
 </Button>
 <Button
 size="sm"
 variant="danger"
 onClick={() => handleDelete(item)}
 >
 Delete
 </Button>
 </td>
 </tr>
 ))}
 {filtered.length === 0 && (
 <tr>
 <td colSpan="6" className="text-center">No offices found</td>
 </tr>
 )}
 </tbody>
 </table>
 </div>
 )}
 </Card.Body>
 </Card>
 </Col>
 </Row>

 <Modal show={showModal} onHide={closeModal} size="lg">
 <Modal.Header closeButton>
 <Modal.Title>{editId ? "Edit Office" : "Add Office"}</Modal.Title>
 </Modal.Header>
 <Modal.Body>
 <Form>
 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Company Logo</Form.Label>
 <div className="d-flex align-items-center gap-3">
 {(logoFile || form.logo) && (
 <img
 src={logoFile ? URL.createObjectURL(logoFile) : `${process.env.REACT_APP_API_URL}/${form.logo}`}
 alt="Logo Preview"
 style={{ height: "60px", width: "60px", objectFit: "contain", border: "1px solid #ddd", padding: "2px" }}
 />
 )}
 <Form.Control
 type="file"
 name="logo"
 onChange={handleChange}
 accept="image/*"
 />
 </div>
 </Form.Group>
 </Col>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Company Slogan</Form.Label>
 <Form.Control
 name="slogan"
 value={form.slogan}
 onChange={handleChange}
 placeholder="Enter company slogan"
 />
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Office Name (e.g. Mumbai Branch)</Form.Label>
 <Form.Control
 name="officeName"
 value={form.officeName}
 onChange={handleChange}
 placeholder="Enter office name"
 />
 </Form.Group>
 </Col>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Company Name</Form.Label>
 <Form.Control
 name="companyName"
 value={form.companyName}
 onChange={handleChange}
 placeholder="Enter company name"
 />
 </Form.Group>
 </Col>
 </Row>

 <Form.Group className="mb-3">
 <Form.Label>Address</Form.Label>
 <Form.Control
 as="textarea"
 rows={3}
 name="address"
 value={form.address}
 onChange={handleChange}
 placeholder="Enter full address"
 />
 </Form.Group>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>State</Form.Label>
 <Form.Select
 name="state"
 value={form.state}
 onChange={handleChange}
 >
 <option value="">Select State</option>
 {STATE_LIST.map((s) => (
 <option key={s.code} value={s.name}>
 {s.name}
 </option>
 ))}
 </Form.Select>
 </Form.Group>
 </Col>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>State Code</Form.Label>
 <Form.Control
 name="stateCode"
 value={form.stateCode}
 readOnly
 placeholder="State code"
 className="premium-bg"
 />
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Email ID</Form.Label>
 <Form.Control
 name="emailId"
 value={form.emailId}
 onChange={handleChange}
 placeholder="Enter email"
 />
 </Form.Group>
 </Col>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>GSTIN</Form.Label>
 <Form.Control
 name="gstin"
 value={form.gstin}
 onChange={handleChange}
 placeholder="Enter GSTIN"
 />
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Phone</Form.Label>
 <Form.Control
 name="phone"
 value={form.phone}
 onChange={handleChange}
 placeholder="Enter phone number"
 />
 </Form.Group>
 </Col>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Website</Form.Label>
 <Form.Control
 name="website"
 value={form.website}
 onChange={handleChange}
 placeholder="https://..."
 />
 </Form.Group>
 </Col>
 </Row>

 <Form.Check
 type="checkbox"
 label="Active"
 name="isActive"
 checked={form.isActive}
 onChange={handleChange}
 />
 </Form>
 </Modal.Body>
 <Modal.Footer>
 <Button variant="secondary" onClick={closeModal}>
 Cancel
 </Button>
 <Button variant="primary" onClick={handleSave} disabled={saving}>
 {saving ? "Saving..." : "Save Office"}
 </Button>
 </Modal.Footer>
 </Modal>
 </Fragment>
 );
};

export default OfficeMaster;
